module.exports = "<jujo_component specialized=\"true\" comp=\"shop_management/sample_configuration\"></jujo_component>"